export function createAttribute(name) {
  return `data-base-ui-${name}`;
}